import {
  ASYNC_START,
  ASYNC_END,
  REDIRECT
} from "../constants/common.action.types";
import {
  LOGIN,
  LOGOUT,
  REGISTER,
  INTEREST
} from "../constants/auth.action.types";
import {
  ASSET_CREATE,
  ASSET_IMPORT,
  ASSET_UPDATE,
  SITE_CREATE,
  SITE_UPDATE,
  LOG_EVENT,
  CAMPAIGN_CREATE,
  CAMPAIGN_UPDATE,
  ADD_CAMPAIGN_ITEM
} from "../constants/asset.action.types";

const defaultState = {
  currentUser: null,
  token: null,
  redirectTo: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case REDIRECT:
      return { ...state, redirectTo: null };
    case LOGIN:
    case REGISTER:
      return {
        ...state,
        token: action.error
          ? null
          : action.payload
          ? action.payload.token
          : null,
        currentUser: action.error ? null : action.payload,
        redirectTo: action.error
          ? null
          : action.payload.token
          ? "/campaigns"
          : ""
      };
    case LOGOUT:
      return { ...state, redirectTo: "/", token: null, currentUser: null };
    // case INTEREST:
    //   return { ...state, redirectTo: action.error ? null : "/" };
    case ASSET_CREATE:
    case ASSET_UPDATE:
    case ASSET_IMPORT:
      return {
        ...state,
        redirectTo: action.error ? null : "/assets"
      };
    case SITE_CREATE:
    case SITE_UPDATE:
      return {
        ...state,
        redirectTo: action.error ? null : "/sites"
      };
    case LOG_EVENT:
      let redirectTo = !action.from
        ? "/events"
        : action.from === "site"
        ? `/sites/${action.key}`
        : `/assets/${action.key}`;
      return {
        ...state,
        redirectTo: action.error ? null : redirectTo
      };
    case CAMPAIGN_CREATE:
    case CAMPAIGN_UPDATE:
      return {
        ...state,
        redirectTo: action.error ? null : "/campaigns"
      };
    case ADD_CAMPAIGN_ITEM:
      return {
        ...state,
        redirectTo: action.error
          ? null
          : "/campaigns/" +
            action.key +
            "/items/edit?added=" +
            new Date().getTime()
      };
    case ASYNC_START:
      return { ...state, inProgress: true };
    case ASYNC_END:
      return { ...state, inProgress: false };
    default:
      return state;
  }
};
